"use strict";
var createTypedArrayConstructor = require("../internals/typed-array-constructor");
createTypedArrayConstructor("Int32", function(init) {
  return function Int32Array(data, byteOffset, length) {
    return init(this, data, byteOffset, length);
  };
});
